import request from '@/utils/request'

export function getBoards(params) {
  return request({
    url: '/internalTask/getBoards',
    method: 'get',
    params,
  })
}

export function saveBoards(data) {
  return request({
    url: '/internalTask/saveBoards',
    method: 'post',
    data,
  })
}
